import { useMemo, useState } from 'react';

import { contactUs } from '../util/api';

const normalizeString = value => (typeof value === 'string' ? value.trim() : '');

const getCurrentUserName = currentUser => {
  const profile = currentUser?.attributes?.profile || {};
  const firstName = normalizeString(profile.firstName);
  const lastName = normalizeString(profile.lastName);

  return (
    normalizeString(profile.displayName) ||
    [firstName, lastName].filter(Boolean).join(' ') ||
    ''
  );
};

export const useContactUsRequest = ({ currentUser }) => {
  const [inProgress, setInProgress] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const initialValues = useMemo(
    () => ({
      senderName: getCurrentUserName(currentUser),
      senderEmail: normalizeString(currentUser?.attributes?.email),
      message: '',
    }),
    [currentUser]
  );

  const submitContactRequest = async values => {
    setInProgress(true);
    setError(null);

    try {
      await contactUs({
        senderName: values?.senderName,
        senderEmail: values?.senderEmail,
        message: values?.message,
        currentUserId: currentUser?.id?.uuid || null,
        pageUrl: typeof window !== 'undefined' ? window.location.href : '',
      });
      setSuccess(true);
    } catch (e) {
      setError(e);
    } finally {
      setInProgress(false);
    }
  };

  return {
    error,
    initialValues,
    inProgress,
    submitContactRequest,
    success,
  };
};

export default useContactUsRequest;
